module.exports = __webpack_public_path__ + "img/johnluigi.5e24c5ae.jpeg";